/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const initiateBodyExpectedVersionExclusiveMin = 0;
export const initiateBodyExpectedVersionMax = 9007199254740991;

export const InitiateBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(initiateBodyExpectedVersionExclusiveMin)
    .max(initiateBodyExpectedVersionMax),
  transport: zod.enum(['email-link', 'sms-code', 'voice-code']),
});

export type InitiateBody = zod.input<typeof InitiateBody>;
export type InitiateBodyOutput = zod.output<typeof InitiateBody>;
